import { makeObservable, observable, action } from 'mobx';
import type { ProQaEventMetadataResponse } from '@mark43/cad-api';

export class ProQaMetadataStore {
    @observable
    public proQaMetadata?: ProQaEventMetadataResponse;

    constructor() {
        makeObservable(this);
    }

    @action
    setProQaMetadata(data: ProQaEventMetadataResponse): void {
        this.proQaMetadata = data;
    }

    @action
    clearProQaMetadata(): void {
        this.proQaMetadata = undefined;
    }
}
